import React, { PureComponent } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { routes } from "../../../routing/routes";

class Home extends PureComponent {
  render() {
    const { user = {}, location } = this.props;
    let redirectRoute = routes.OVERVIEW;
    if (user && user.role && user.role === "Operator") {
      redirectRoute = routes.OPERATORVIEW;
    }
    return (
      <Redirect
        to={{
          pathname: redirectRoute,
          state: { from: location },
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.Auth.user,
  };
}

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
